import * as React from "react";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import PaginatedItemOverview from "components/common/PaginatedItemOverview";
import SectionComponent from "components/common/Section/SectionComponent";
import RolesQueryHelp from "components/users/RolesQueryHelp";
import TeamsDomain from "../../domainActions/TeamsDomain";
const RolesSection = ({ team: { id, name } }) => {
  const { t } = useTranslation("enterprise_security");
  const [loading, setLoading] = useState(false);
  const _onLoad = useCallback(
    (pagination, isSubscribed) => {
      setLoading(true);
      return TeamsDomain.loadRolesForTeam(id, name, pagination).then((paginatedRoles) => {
        if (isSubscribed) {
          setLoading(false);
        }
        return paginatedRoles;
      });
    },
    [id, name]
  );
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("team_details_roles.title"), showLoading: loading }, /* @__PURE__ */ React.createElement(
    PaginatedItemOverview,
    {
      noDataText: t("team_details_roles.no_data"),
      onLoad: _onLoad,
      queryHelper: /* @__PURE__ */ React.createElement(RolesQueryHelp, null)
    }
  ));
};
export default RolesSection;
